export default __webpack_public_path__ + "static/media/animated-logo-once.676b310d.svg";